import INVENTORY_API_BASE_URL from "../../config/api";
import styles from "./approvedpo.module.css";
import { useState, useEffect } from "react";
import Axios from "axios";
import React from "react";
import swal from "sweetalert";
import logUserActivity from "../utils/logUserActivity";

function ApproveDPO() {
  const [data, setData] = useState([]);
  const [ApprovalDate, setApprovalDate] = useState();
  const [orderquantity, setorderquantity] = useState();
  const [filteredData, setFilteredData] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [approved, setapproved] = useState();
  const [selectedVendor, setSelectedVendor] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [expandedShipmentIds, setExpandedShipmentIds] = useState([]);

  function formatDate(dateString) {
    const date = new Date(dateString);
    const options = { day: "numeric", month: "long", year: "numeric" };
    return date.toLocaleDateString("en-US", options);
  }

  useEffect(() => {
    Axios.get(`${INVENTORY_API_BASE_URL}/getApproveDPO`)
      .then((response) => {
        const latest30Data = response.data;
        setData(latest30Data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, []);

  const toggleShipmentData = (shipmentId) => {
    setExpandedShipmentIds((prevIds) =>
      prevIds.includes(shipmentId)
        ? prevIds.filter((id) => id !== shipmentId)
        : [shipmentId]
    );
  };

  const deleteOrder = async (id) => {
    const confirmDelete = await swal({
      title: "Are you sure?",
      text: "Do you really want to reject this order?",
      icon: "warning",
      buttons: ["Cancel", "Reject"],
      dangerMode: true,
    });

    if (confirmDelete) {
      try {
        const orderToDelete = data.find((order) => order._id === id);

        await Axios.delete(`${INVENTORY_API_BASE_URL}/deleteDPO/${id}`);

        await logUserActivity("REJECT_DPO", {
          deletedOrder: orderToDelete,
        });

        swal("Order Rejected", { icon: "success" });

        setData((prevData) => prevData.filter((order) => order._id !== id));
      } catch (err) {
        console.error("Error rejecting order:", err);
        swal("Error", "Failed to reject order", { icon: "error" });
      }
    }
  };

  const handleSearch = () => {
    if (!searchTerm.trim()) {
      setFilteredData([]);
      setIsSearching(false);
      return;
    }

    const lowerTerm = searchTerm.toLowerCase();

    const filtered = data.filter(
      (row) =>
        String(row.shipmentid).toLowerCase().includes(lowerTerm) ||
        String(row.Dorderid).toLowerCase().includes(lowerTerm)
    );

    setFilteredData(filtered);
    setIsSearching(true);
    setCurrentPage(1);
  };

  useEffect(() => {
    if (data.length > 0) {
      const pages = Math.ceil(data.length / itemsPerPage);
      setTotalPages(pages);
    }
  }, [data, itemsPerPage]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const paginate = (array, page_number, page_size) => {
    return array.slice((page_number - 1) * page_size, page_number * page_size);
  };

  const giveDate = async (id) => {
    if (approved === undefined) {
      swal({ title: "Please enter Approved Quantity", icon: "warning" });
      return;
    }

    if (!ApprovalDate) {
      swal({ title: "Please select Date", icon: "warning" });
      return;
    }

    if (!selectedVendor) {
      swal({ title: "Please select Dispatch Method", icon: "warning" });
      return;
    }

    try {
      await Axios.put(`${INVENTORY_API_BASE_URL}/ApproveDPO`, {
        id,
        ApprovalDate,
        updatedQuantity: approved,
        approvedOrderValue: orderquantity,
        dispatchthrough: selectedVendor,
      });

      await logUserActivity("APPROVE_DPO", {
        orderId: id,
        approvalDate: ApprovalDate,
        dispatchThrough: selectedVendor,
        approvedItems: approved.map((item) => ({
          sku: item.sku,
          title: item.title,
          approvedquantity: item.approvedquantity,
          mrp: item.mrp,
          PurchaseValue: item.PurchaseValue,
          OrderValue: item.approvedOrderValue,
        })),
      });

      swal({ title: "Order Approved", icon: "success" });
      window.location.reload();
    } catch (err) {
    }
  };

  function calculatePurchaseValue(quantity, price, discountValue) {
    const purchaseValue = quantity * (price - discountValue);
    return purchaseValue;
  }

  const handleQuantityChange = (event, rowId, sku, orderid, purchaseValue) => {
    const { value } = event.target;
    const approvedOrderValue = value * purchaseValue;
    setorderquantity();
    setData((prevData) => {
      const updatedData = prevData.map((rowData) => {
        if (rowData._id === rowId) {
          const updatedOrder = rowData.Porder.map((item) =>
            item.sku === sku
              ? {
                  ...item,
                  oderid: sku.orderid,
                  approvedquantity: value,
                  approvedOrderValue: approvedOrderValue,
                  total: calculatePurchaseValue(
                    value,
                    item.price,
                    item.discountValue
                  ),
                }
              : item
          );

          setapproved(updatedOrder);
          return { ...rowData, Porder: updatedOrder };
        }
        return rowData;
      });

      const updatedRow = updatedData.find((row) => row._id === rowId);
      const updatedItem = updatedRow.Porder.find((item) => item.sku === sku);

      if (updatedItem.approvedquantity !== value) {
        giveDate(rowId, updatedItem.approvedquantity);
      }
      return updatedData;
    });
  };

  useEffect(() => {
    if (data) {
      const filteredRows = data.filter((row) =>
        row.Porder?.some(
          (item) =>
            item.sku.toLowerCase().includes(searchTerm.toLowerCase()) ||
            item.title.toLowerCase().includes(searchTerm.toLowerCase())
        )
      );

      setFilteredData(filteredRows);
    }
  }, [searchTerm, data]);

  useEffect(() => {
    Axios.get(`${INVENTORY_API_BASE_URL}/getApproveDPO`)
      .then((response) => {
        const latest30Data = response.data;
        setData(latest30Data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, []);

  const getPageRange = () => {
    const maxPagesToShow = 15;
    const middlePage = Math.ceil(maxPagesToShow / 2);
    let startPage = Math.max(currentPage - middlePage, 1);
    let endPage = Math.min(startPage + maxPagesToShow - 1, totalPages);

    if (endPage - startPage < maxPagesToShow - 1) {
      startPage = Math.max(endPage - maxPagesToShow + 1, 1);
    }

    endPage = Math.min(endPage, totalPages);

    startPage = Math.max(endPage - maxPagesToShow + 1, 1);

    return Array.from(
      { length: endPage - startPage + 1 },
      (_, index) => startPage + index
    );
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const visibleOrders = paginate(
    isSearching ? filteredData : data,
    currentPage,
    itemsPerPage
  );
  const pendingOrders = data.filter((row) => row.ApprovalDate === null).length;

  return (
    <div className={styles.approvedpowrapper}>
      <main className={styles.DPOcontainer}>
        <div className={styles.DPOcontent}>
          <header className={styles.hero}>
            <div className={styles.heroCopy}>
              <div className={styles.eyebrow}>
                <span className={styles.eyebrowMark} />
                PURCHASE WORKFLOW
              </div>
              <h1>Approve distributor orders</h1>
              <p>
                Review order lines, confirm quantities, and choose how each
                approved order will be dispatched.
              </p>
            </div>
            <div className={styles.heroBadge}>
              <span className={styles.heroBadgeDot} />
              Approval desk
            </div>
          </header>

          <section className={styles.summaryGrid} aria-label="Order summary">
            <article className={styles.summaryCard}>
              <span className={styles.summaryLabel}>Total order groups</span>
              <strong className={styles.summaryValue}>{data.length}</strong>
              <span className={styles.summaryHint}>Orders received</span>
            </article>
            <article className={styles.summaryCard}>
              <span className={styles.summaryLabel}>Awaiting approval</span>
              <strong className={styles.summaryValue}>{pendingOrders}</strong>
              <span className={styles.summaryHint}>Ready for review</span>
            </article>
            <article className={styles.summaryCard}>
              <span className={styles.summaryLabel}>Items per page</span>
              <strong className={styles.summaryValue}>{itemsPerPage}</strong>
              <span className={styles.summaryHint}>Order groups at a time</span>
            </article>
          </section>

          <section className={styles.workspace} aria-label="Purchase orders">
            <div className={styles.toolbar}>
              <div className={styles.searchBlock}>
                <label className={styles.searchLabel} htmlFor="approve-dpo-search">
                  Find an order
                </label>
                <div className={styles.searchControl}>
                  <span className={styles.searchIcon} aria-hidden="true">
                    ⌕
                  </span>
                  <input
                    id="approve-dpo-search"
                    className={styles.searchInput}
                    type="text"
                    placeholder="Search by Shipment ID or Order ID"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                  <button
                    className={styles.searchButton}
                    type="button"
                    onClick={handleSearch}
                  >
                    Search
                  </button>
                </div>
              </div>
              <div className={styles.resultSummary}>
                <span className={styles.resultDot} />
                <span>
                  {isSearching ? filteredData.length : data.length} order groups
                </span>
              </div>
            </div>

            <div className={styles.pagination}>
              <span className={styles.pageSummary}>
                Page <strong>{currentPage}</strong> of{" "}
                <strong>{totalPages}</strong>
              </span>
              <nav className={styles.nmbrrange} aria-label="Order pagination">
                <button
                  className={styles.dpobtn2}
                  type="button"
                  onClick={handlePreviousPage}
                  disabled={currentPage === 1}
                >
                  <span aria-hidden="true">‹</span> Previous
                </button>

                {getPageRange().map((pageNumber) => (
                  <button
                    className={styles.dpobtn}
                    key={pageNumber}
                    type="button"
                    onClick={() => handlePageChange(pageNumber)}
                    disabled={pageNumber === currentPage}
                    aria-current={pageNumber === currentPage ? "page" : undefined}
                  >
                    {pageNumber}
                  </button>
                ))}

                <button
                  className={styles.dpobtn2}
                  type="button"
                  onClick={handleNextPage}
                  disabled={currentPage === totalPages}
                >
                  Next <span aria-hidden="true">›</span>
                </button>
              </nav>
            </div>

            <div className={styles.orderList}>
              {visibleOrders.length === 0 ? (
                <div className={styles.emptyState}>
                  <span className={styles.emptyIcon} aria-hidden="true">
                    ⌕
                  </span>
                  <h2>No order groups to display</h2>
                  <p>
                    {isSearching
                      ? "No distributor orders match that search."
                      : "There are no distributor purchase orders available right now."}
                  </p>
                </div>
              ) : (
                visibleOrders.map((row) => {
                  const isExpanded = expandedShipmentIds.includes(row.shipmentid);

                  return (
                    <article className={styles.orderCard} key={row.shipmentid}>
                      <button
                        className={styles.shipmentbutton}
                        type="button"
                        onClick={() => toggleShipmentData(row.shipmentid)}
                        aria-expanded={isExpanded}
                      >
                        <span className={styles.orderIdentity}>
                          <span className={styles.orderIdentityIcon} aria-hidden="true">
                            PO
                          </span>
                          <span className={styles.orderIdentityCopy}>
                            <span className={styles.orderKicker}>
                              SHIPMENT ID
                            </span>
                            <strong>{row.shipmentid}</strong>
                          </span>
                          <span className={styles.orderDivider} />
                          <span className={styles.orderIdentityCopy}>
                            <span className={styles.orderKicker}>ORDER ID</span>
                            <strong>{row.Dorderid}</strong>
                          </span>
                        </span>
                        <span className={styles.orderMeta}>
                          <span className={styles.itemCount}>
                            {row.Porder.length}{" "}
                            {row.Porder.length === 1 ? "item" : "items"}
                          </span>
                          <span className={styles.expandLabel}>
                            {isExpanded ? "Hide details" : "View details"}
                          </span>
                          <span
                            className={styles.expandChevron}
                            aria-hidden="true"
                          >
                            {isExpanded ? "−" : "+"}
                          </span>
                        </span>
                      </button>

                      {isExpanded && (
                        <div className={styles.orderDetails}>
                          <div className={styles.sectionHeading}>
                            <div>
                              <span className={styles.sectionEyebrow}>
                                ORDER CONTENTS
                              </span>
                              <h2>Items in this order</h2>
                            </div>
                            <span className={styles.orderDateBadge}>
                              Ordered {formatDate(row.orderdate)}
                            </span>
                          </div>

                          <div className={styles.itemsList}>
                            {row.Porder.map((item) => (
                              <article className={styles.itemCard} key={item.sku}>
                                <div className={styles.itemIntro}>
                                  <img
                                    className={styles.itemImage}
                                    src={
                                      "https://d10idqgatxnd06.cloudfront.net/" +
                                      item.img
                                    }
                                    alt={item.title || item.sku}
                                  />
                                  <div className={styles.itemHeading}>
                                    <span className={styles.skuBadge}>
                                      SKU {item.sku}
                                    </span>
                                    <h3>{item.title}</h3>
                                  </div>
                                </div>

                                <dl className={styles.itemDetailsGrid}>
                                  <div className={styles.detailCell}>
                                    <dt>Medium</dt>
                                    <dd>{item.Medium}</dd>
                                  </div>
                                  <div className={styles.detailCell}>
                                    <dt>Edition</dt>
                                    <dd>{item.edition}</dd>
                                  </div>
                                  <div className={styles.detailCell}>
                                    <dt>Order quantity</dt>
                                    <dd>{item.quantity1}</dd>
                                  </div>
                                  <div className={styles.detailCell}>
                                    <dt>Approved quantity</dt>
                                    <dd>
                                      <input
                                        className={styles.inputwithoutspinner}
                                        type="number"
                                        aria-label={
                                          "Approved quantity for " + item.sku
                                        }
                                        value={item.approvedquantity}
                                        onChange={(e) =>
                                          handleQuantityChange(
                                            e,
                                            row._id,
                                            item.sku,
                                            row.orderid,
                                            item.PurchaseValue
                                          )
                                        }
                                        onWheel={(e) => e.target.blur()}
                                      />
                                    </dd>
                                  </div>
                                  <div className={styles.detailCell}>
                                    <dt>MRP</dt>
                                    <dd>{item.mrp}</dd>
                                  </div>
                                  <div className={styles.detailCell}>
                                    <dt>Purchase price</dt>
                                    <dd>{item.PurchaseValue}</dd>
                                  </div>
                                  <div className={styles.detailCell}>
                                    <dt>Order value</dt>
                                    <dd>{item.approvedOrderValue}</dd>
                                  </div>
                                </dl>
                              </article>
                            ))}
                          </div>

                          <section className={styles.approvalPanel}>
                            <div className={styles.approvalHeading}>
                              <div>
                                <span className={styles.sectionEyebrow}>
                                  FINAL REVIEW
                                </span>
                                <h2>Approval &amp; dispatch</h2>
                              </div>
                              {row.ApprovalDate === null ? (
                                <span className={styles.pendingBadge}>
                                  <span />
                                  Pending approval
                                </span>
                              ) : (
                                <span className={styles.approvedBadge}>
                                  <span />
                                  Approved
                                </span>
                              )}
                            </div>

                            <div className={styles.approvalControls}>
                              <label className={styles.field}>
                                <span>Approval date</span>
                                {row.ApprovalDate === null ? (
                                  <input
                                    className={styles.dateInput}
                                    type="date"
                                    placeholder="Date of approval"
                                    onChange={(e) => {
                                      setApprovalDate(e.target.value);
                                    }}
                                  />
                                ) : (
                                  <strong className={styles.approvedDate}>
                                    {formatDate(row.ApprovalDate)}
                                  </strong>
                                )}
                              </label>

                              <label className={styles.field}>
                                <span>Dispatch through</span>
                                <select
                                  className={styles.selectoption}
                                  value={selectedVendor}
                                  onChange={(e) =>
                                    setSelectedVendor(e.target.value)
                                  }
                                >
                                  <option value="">Select dispatch method</option>
                                  <option value="Pinnacle">Pinnacle</option>
                                  <option value="Shivalik Enterprises">
                                    Shivalik Enterprises
                                  </option>
                                  <option value="Pinnacle(Quick)">
                                    Pinnacle(Quick)
                                  </option>
                                </select>
                              </label>
                            </div>

                            <div className={styles.actionRow}>
                              <div className={styles.actionNote}>
                                {row.ApprovalDate === null
                                  ? "Check quantities and dispatch details before approving."
                                  : "This distributor order has been approved."}
                              </div>
                              <div className={styles.actionButtons}>
                                {row.ApprovalDate === null ? (
                                  <button
                                    className={styles.approvebutton1}
                                    type="button"
                                    onClick={() => {
                                      giveDate(row._id);
                                    }}
                                  >
                                    Approve order
                                  </button>
                                ) : (
                                  <span className={styles.approvedStatus}>
                                    Approved
                                  </span>
                                )}
                                <button
                                  className={styles.rejectbutton1}
                                  type="button"
                                  onClick={() => {
                                    deleteOrder(row._id);
                                  }}
                                >
                                  Reject order
                                </button>
                              </div>
                            </div>
                          </section>
                        </div>
                      )}
                    </article>
                  );
                })
              )}
            </div>
          </section>
        </div>
      </main>
    </div>
  );
}

export default ApproveDPO;
